import { TextEntryFilterOption } from '../types';
import { CSVTextEntry } from '../../components';

export const config: TextEntryFilterOption = {
  id: 'omicsExplorer.filters.dbsnprsIds',
  title: {
    id: 'omicsExplorer.filters.dbsnprsIds',
    defaultMessage: 'dbSNP rs IDs',
  },
  content: CSVTextEntry,
  injectedProps: {
    searchKey: 'rsid',
    textEntryOption: {
      id: 'omicsExplorer.filters.dbsnprsIds',
      searchValue: '',
      placeholderIntlLabel: {
        id: 'omicsExplorer.filters.dbsnprsIds.placeholderLabel',
        defaultMessage: 'Add (comma-separated)',
      },
    },
  },
};
